<template>
  <div class="row h-100 no-gutters">
    <div class="auth-form mx-auto my-auto col-md-5 col-lg-3">
      <div class="card">
        <div class="card-body">
          <h1 style="text-align: center">
            <img
              id="main-logo"
              class="d-inline-block align-top mr-1"
              style="max-width: 100px;"
              src="@/assets/images/logo.jpg"
              alt="" />
          </h1>
          <d-alert
            v-if="error"
            theme="danger"
            show>
            Błąd podczas resetowania hasła. Spróbuj ponownie.
          </d-alert>
          <d-alert
            v-if="success"
            theme="success"
            show>
            Link do resetu hasła został wysłany na podany adres e-mail.
          </d-alert>

          <h4 class="text-center mt-4 mb-4">
            Przypomnienie hasła
          </h4>

          <validation-observer ref="password-reset-form" tag="form">
            <validation-provider
              rules="required|email"
              name="email"
              v-slot="{ errors }">
              <div class="form-group">
                <label>Adres e-mail:</label>
                <d-input
                  v-model="email"
                  name="email"
                  type="email"
                  :state="errors.length ? 'invalid' : null"
                  placeholder="Twój adres e-mail" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </div>
            </validation-provider>

            <d-button
              pill
              class="ml-auto mr-auto mt-4 d-table"
              @click.prevent="validateForm"
              :disabled="submitting">
              <template v-if="!submitting">Resetuj hasło</template>
              <template v-else>Resetowanie hasła&hellip;</template>
            </d-button>
          </validation-observer>

          <div class="pt-3 text-center">
            <small>
              <router-link to="/login">
                Zaloguj się
              </router-link>
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormUtils from './../utils/FormUtils.js';

export default {
  name: 'PasswordReset',
  data () {
    return {
      error: false,
      submitting: false,
      success: false,
      email: ''
    }
  },
  methods: {
    validateForm () {
      FormUtils.validate(this.$refs['password-reset-form'], this.reset);
    },
    reset () {
      this.error = false;
      this.submitting = true;
      this.success = false;

      this.$http.post('/password/email', {
        email: this.email
      }).then((response) => {
        this.submitting = false;

        if (response.data.success) {
          this.success = true;
        } else {
          this.error = true;
        }
      }).catch(() => {
        this.submitting = false;
        this.error = true;
      });
    }
  }
}
</script>
